export enum EditPopupType {
  Error = 'edit-error',
  OnReview = 'edit-on-review',
}

export interface RemoveAdPayload {
  delete_reason_description: string;
  id: string;
  name: string;
}
